export default __webpack_public_path__ + "static/4-f24527bbe8fa82e61109870e58f603cf.jpg";